import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=5eee1f3c&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=5eee1f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eee1f3c",
  null
  
)

export default component.exports